import render from './render';

const animate = ({
  camera,
  controls,
  intersected,
  mouse,
  raycaster,
  renderer,
  scene,
}: {
  camera: any;
  controls: any;
  intersected: any;
  mouse: any;
  raycaster: any;
  renderer: any;
  scene: any;
}): void => {
  controls.update();

  window.allDimensionTexts3d.forEach((item: any) => {
    item.lookAt(camera.position);
  });

  render({
    camera,
    intersected,
    mouse,
    raycaster,
    renderer,
    scene,
  });
};

export default animate;
